<template>
    <div class="personages-manager">
        <slot name="trigger" :open="open">
            <button
                v-t="'personages.manager.trigger'"
                class="button button--blank"
                @click.prevent="open"
            ></button>
        </slot>

        <portal to="modals">
            <Modal
                v-if="show"
                :title="$t('personages.manager.title')"
                name="personages-manager"
                modal-class="personages-manager__modal"
                no-max-width
                @close="close"
            >
                <template #content>
                    <PaginatedResource
                        ref="personagesResource"
                        :fetch-method="fetchPersonages"
                        :page-size="20"
                        :filter-fields="['book']"
                        delay-fetch
                    >
                        <template
                            #default="{ loading, sort, resource: personages, canLoadMore, loadMore }"
                        >
                            <div
                                :class="[
                                    'personages-manager__list',
                                    { 'is-empty': !personages.length }
                                ]"
                            >
                                <Spinner v-if="loading" />
                                <PersonagesTable
                                    ref="personagesTableRes"
                                    :personages="personages"
                                    @personageUpdate="onPersonagesChanged"
                                    @personageDelete="onPersonagesChanged"
                                    @sort="sort"
                                />
                                <div v-if="canLoadMore" class="personages-manager__loadmore">
                                    <button
                                        v-t="'misc.loadmore'"
                                        class="button button--big button--blank"
                                        type="button"
                                        @click="loadMore"
                                    />
                                </div>
                                <PersonagesAdd
                                    v-if="!loading"
                                    ref="personagesAddRes"
                                    class="personages-manager__add"
                                    :skip-trigger="!personages.length"
                                    @personageAdded="onPersonagesChanged"
                                />
                            </div>
                        </template>
                    </PaginatedResource>
                </template>
                <template #bottom>
                    <button
                        type="button"
                        :disabled="loading"
                        :class="['button button--big button--outlined', { 'is-disabled': loading }]"
                        @click="close"
                        v-text="$t('misc.cancel')"
                    />
                    <button
                        :disabled="loading"
                        :class="['button button--big', { 'is-disabled': loading }]"
                        @click="save"
                        v-text="$t('misc.save')"
                    />
                </template>
            </Modal>
        </portal>
    </div>
</template>

<script>
import { fetchPersonages } from '../../api/personages';
import { Modal } from '@speechki-frontend/shared/ui/modals';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import PersonagesTable from './PersonagesTable';
import PersonagesAdd from './PersonagesAdd';
import { mapState } from 'vuex';

export default {
    name: 'PersonagesManager',
    components: {
        Modal,
        PaginatedResource,
        Spinner,
        PersonagesTable,
        PersonagesAdd
    },
    data() {
        return {
            show: false,
            loading: false,
            error: undefined
        };
    },
    computed: {
        ...mapState({
            book: ({ book }) => book.book
        })
    },
    methods: {
        fetchPersonages,

        async open() {
            this.loading = true;
            this.show = true;
            this.$emit('opened');

            await this.$nextTick();
            await this.fetchPersonagesResource();

            this.loading = false;
        },
        close() {
            this.show = false;
            this.$emit('closed');
        },
        async fetchPersonagesResource() {
            const { id: book } = this.book;
            this.$refs.personagesResource.filter({ book });
        },
        async onPersonagesChanged() {
            window.dispatchEvent(new CustomEvent(`personages-updated`));

            await this.refetchPersonages();
        },
        async refetchPersonages() {
            this.loading = true;
            await this.fetchPersonagesResource();
            this.loading = false;
        },
        async save() {
            this.loading = true;
            try {
                await Promise.all([
                    this.$refs.personagesAddRes.save(),
                    this.$refs.personagesTableRes.save()
                ]);
            } catch (err) {
                console.log(err);
            } finally {
                this.loading = false;
                this.close();
            }
        }
    }
};
</script>

<style lang="scss" src="./PersonagesManager.scss"></style>
